import Image from 'next/image';

import { cn } from '@/services/utils/classnames';

type AuthLogoProps = {
  className?: string;
};

export const AuthLogo = ({ className }: AuthLogoProps) => {
  return (
    <Image
      src="/logo-horizontal.svg"
      height={131}
      width={569}
      alt="DigiProc logo white"
      priority
      className={cn(
        'absolute left-1/2 top-[36px] w-[423px] -translate-x-1/2 brightness-0 invert dp-md:left-[96px] dp-md:top-[277px] dp-md:translate-x-0 dp-lg:left-[200px]',
        className
      )}
    />
  );
};
